import { fetchWrapper, hcUrlV3, handleResponse, buildOpts } from 'services/RequestService/helpers';

const getRestartCampaign = async ({ id }) => {
  const url = id ? `/reactivate?restart_campaign_id=${id}` : '/reactivate';
  const response = await fetchWrapper(hcUrlV3(url), buildOpts());
  return handleResponse(response);
};

export { getRestartCampaign };
